import _ from 'lodash';
import PublicEnv from 'shared/utils/public-env';

let amplitudeClient = {
  init: _.noop,
  logEvent: _.noop,
  setUserId: _.noop,
  setUserProperties: _.noop,
};

// we need to prevent import on the serverside
if (typeof window !== 'undefined') {
  // eslint-disable-next-line global-require
  const amplitude = require('amplitude-js');
  amplitudeClient = amplitude.getInstance();
}

const setupAmplitude = _.once(() => {
  // similarly here we want to prevent this from firing on the server (next.js)
  if (typeof window !== 'undefined') {
    amplitudeClient.init(PublicEnv.amplitudeApiKey);
    amplitudeClient.setVersionName(PublicEnv.herokuSlugCommit);
  }
});

export const getCartEventProperties = (Cart, UI) => ({
  orderTotal: (Cart?.costBreakdown?.total ?? 0).toFixed(2),
  rewardRedemption: !!(Cart?.order?.appliedRewards?.length > 0),
  couponRedemption: !!Cart?.order?.coupon,
  saleRedemption: Cart?.costBreakdown?.credit > 0,
  paymentType: Cart?.order?.paymentMethod,
  dispensaryId: Cart?.dispensary?.id,
  dispensaryName: Cart?.dispensary?.name,
  menuVariant: UI.analyticsMenuVariant,
});

export const AmplitudeCategory = Object.freeze({
  menu: 'Menu',
  checkout: 'Checkout',
  paymentsMoneris: 'Payments-Moneris',
  paymentsMerrco: 'Payments-Merrco',
  paymentChase: 'Payments-Chase',
});

export const AmplitudeEvents = {
  checkout: {
    placeOrder: `Place Order`,
    clickSave: `Click Save`,
    goToCheckout: `Go to Checkout`,
    createAccount: `Create Account`,
  },
  payments: {
    // nesting this assuming there will be other payment modals
    moneris: {
      onSave: `User clicks save`,
      onError: `Invalid input`,
    },
  },
  menu: {
    viewHomepage: `View Homepage`,
    viewCategory: `View a Category Page`,
    viewBrand: `View Brand Page`,
    viewProduct: `View Product Detail Page`,
    addToCart: `Add to Cart`,
    quickAdd: `Add to Cart - Quick Add`,
    viewSpecials: `View Specials Page`,
    clickedIndividualCannabinoid: 'Clicked Individual Cannabinoid',
  },
};

export const AmplitudePaymentFormEventDescriptions = {
  moneris: {
    onSaveSuccess: 'Save Card Info: Success',
    onError: 'Save Card Info: Fail - ',
  },
};

export function useAmplitude() {
  try {
    setupAmplitude();
  } catch (error) {
    window.Rollbar.error('Amplitude initialization error: ', error);
  }
  const log = (event, data) => {
    try {
      amplitudeClient.logEvent(event, data);
    } catch (error) {
      window.Rollbar.error('Amplitude logEvent error: ', error);
    }
  };

  return { log };
}
